<template>

<div>
  <div class="header-container">
    <h2>Partes de Trabajo</h2>
    <work-order-filter v-model="filters" @click-search="filterWorkOrders" hide-type-filter hide-validation-status-filter :typeList="0"/>
    <b-pagination v-model.number="paginator.page" @change="loadWorkOrders" align="center"
                  :per-page="paginator.perPage" :total-rows="paginator.totalElements"/>
  </div>
  <div class="fixed-table-container">
    <work-order-table :items="paginator.content" :buttons="buttons" :fields="fields"
                      @clickEdit="openEditModal" @click-confirm="confirmWorkOrder" @sortChanged="onSortChange" @click-delete="deleteWorkOrder"/>
  </div>
  <b-modal ref="confirmDialog" title="¿Está Seguro?" ok-title="Confirmar" cancel-title="Cancelar"
           ok-variant="success" header-bg-variant="success" header-text-variant="light">
    <p>¿Está seguro de que desea confirmar el parte?</p>
  </b-modal>
  <b-modal ref="deleteDialog" title="¿Está Seguro?" ok-title="Eliminar" cancel-title="Cancelar"
           ok-variant="danger" header-bg-variant="danger" header-text-variant="light">
    <p>¿Está seguro de que desea eliminar el parte?</p>
  </b-modal>
  <edit-work-order-modal ref="editModal" @modify="onModify" @confirm="onConfirm" @delete="deleteWorkOrder" @cambioProyecto="cambioProyecto()" modal-id="editModal" :initialWorkOrder="selectedWorkOrder"/>
</div>

</template>

<script>

import EditWorkOrderModal from './partials/EditWorkOrderModal'
import WorkOrderFilter from './partials/WorkOrderFilter'
import WorkOrderTable from './partials/WorkOrderTable'
import api from '@/api/api'
import {session} from '@/auth'

const MEAL_COST_OPTIONS = {
  FULL: {value: 'FULL', text: 'Completa'},
  HALF: {value: 'HALF', text: 'Media'},
  NONE: {value: 'NONE', text: 'Ninguna'}
}
const translateMealCost = value => MEAL_COST_OPTIONS[value].text
const formatDecimal = value => value % 1 === 0 ? value : value.toFixed(2).replace('.', ',')

export default {
  name: 'WorkOderIndex',
  components: {
    EditWorkOrderModal,
    WorkOrderFilter,
    WorkOrderTable
  },
  created() {
    this.loadWorkOrders()
  },
  mounted() {
    window.addEventListener('keyup', (event) => {
      if (event.keyCode === 13 && this.$refs.confirmDialog.is_show) {
        this.$refs.confirmDialog.hide()
        this.onConfirm(this.workOrder)
      }
    })
  },
  data() {
    return {
      selectedWorkOrder: null,
      paginator: {
        page: 1,
        perPage: 10,
        totalElements: 0,
        content: []
      },
      sort: 'workOrderDate,desc',
      filters: {},
      workOrder: {},
      fields: [
        {key: 'id', label: 'Parte', sortable: true, thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
        {key: 'validationStatus', label: 'Estado', sortable: true, formatter: (v, k, item) => item.statusLabel},
        {key: 'workOrderDate', label: 'Fecha', sortable: true},
        {key: 'employeeName', label: 'Operario', sortable: true},
        {key: 'projectCodeId', label: 'Proyecto', sortable: true, formatter: (v, k, item) => v + ' - ' + item.projectTitle},
        {key: 'project.client.name', label: 'Cliente', sortable: true, formatter: (v, k, item) => item.clientName},
        {
          key: 'preventiveResource',
          label: 'Recurso',
          class: 'text-center',
          thStyle: {width: '60px'},
          tdAttr: {width: '60px'},
          formatter: v => v ? 'Si' : 'No'
        },
        {key: 'ordinaryHours', label: 'Horas', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
        {key: 'overtimeHours', label: 'Extra', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
        {key: 'pauseHours', label: 'Pausa', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
        {
          key: 'mealCostType',
          label: 'Dietas',
          thStyle: {width: '50px'},
          tdAttr: {width: '50px'},
          formatter: v => translateMealCost(v)
        },
        {key: 'travelKm', label: 'Km', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
        {
          key: 'shiftWork',
          label: 'Turnicidad',
          class: 'text-center',
          thStyle: {width: '75px'},
          tdAttr: {width: '75px'},
          formatter: v => v ? 'Si' : 'No'
        },
        {
          key: 'nightShift',
          label: 'Nocturnidad',
          class: 'text-center',
          thStyle: {width: '90px'},
          tdAttr: {width: '90px'},
          formatter: v => v ? 'Si' : 'No'
        },

        {
          key: 'onCallDuty',
          label: 'Guardia',
          class: 'text-center',
          thStyle: {width: '60px'},
          tdAttr: {width: '60px'},
          formatter: v => v ? 'Si' : 'No'
        },
        {
          key: 'saturday',
          label: 'Sábado',
          class: 'text-center',
          thStyle: {width: '60px'},
          tdAttr: {width: '60px'},
          formatter: v => v ? 'Si' : 'No'
        },
        {
          key: 'holiday',
          label: 'Festivo',
          class: 'text-center',
          thStyle: {width: '60px'},
          tdAttr: {width: '60px'},
          formatter: v => v ? 'Si' : 'No'
        },

        {key: 'comments', label: 'Observaciones'},
        {key: 'buttons', label: 'Gestión'}
      ]
    }
  },
  computed: {
    buttons() {
      const buttons = ['edit', 'confirm']
      if ((session.authorities != null) && session.authorities.includes('ROLE_WORK_ORDER_DELETE')) {
        buttons.push('delete')
      }

      return buttons
    }
  },
  methods: {
    filterWorkOrders() {
      this.loadWorkOrders(1)
    },
    loadWorkOrders(page = this.paginator.page) {
      return api.workOrder.index(this.getParams(page)).then(paginator => {
        this.paginator.content = paginator.content
        this.paginator.totalElements = paginator.totalElements
        this.paginator.page = page
      })
    },
    getParams(page) {
      return {
        ...this.filters,
        page: page - 1,
        size: this.paginator.perPage,
        sort: this.sort
      }
    },
    confirmWorkOrder(workOrder) {
      this.workOrder = workOrder
      this.$refs.confirmDialog.$off('ok') // very important. clear previous custom event listeners
      this.$refs.confirmDialog.$once('ok', () => {
        this.onConfirm(workOrder)
      })
      this.$refs.confirmDialog.show()
    },
    openEditModal(workOrder) {
      this.selectedWorkOrder = workOrder
      this.$refs.editModal.show(workOrder)
    },
    onSortChange(context) {
      this.sort = context.sortBy && context.sortBy + ',' + (context.sortDesc ? 'desc' : 'asc')
      this.loadWorkOrders(1)
    },
    onModify(workOrder) {
      // var hayNuevoProyecto = (workOrder.newProject != null) && (workOrder.newProject.codeId != null)
      // if (hayNuevoProyecto) {
      //   var changeProjectParams = {
      //     idProject: workOrder.newProject.id,
      //     idWorkOrder: workOrder.id
      //   }
      //   api.workOrder.changeProject(changeProjectParams).then(() => {})
      // }

      api.workOrder.modify(workOrder).then(() => {
        this.loadWorkOrders()
        this.$toastr('success', 'Parte Modificado')
      })

      // this.loadWorkOrders()
    },
    onConfirm(workOrder) {
      api.workOrder.confirm(workOrder.id).then(() => {
        this.loadWorkOrders()
        this.$toastr('success', 'Parte Validado')
      })
    },
    deleteWorkOrder(workOrder) {
      this.$refs.deleteDialog.$off('ok') // very important. clear previous custom event listeners
      this.$refs.deleteDialog.$once('ok', () => {
        api.workOrder.delete(workOrder.id).then(() => {
          this.loadWorkOrders().then(() => this.$toastr('success', 'Parte Eliminado'))
        })
      })
      this.$refs.deleteDialog.show()
    },
    cambioProyecto() {
      this.loadWorkOrders()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/workOrder/Index.vue